import * as React from 'react';
import { DefaultButton, FontIcon, mergeStyles, MessageBar, MessageBarType, Panel, PanelType, PrimaryButton, ProgressIndicator, Stack, Text, useTheme } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import * as Services from '../../../../../Services/Services';
import { IStatusMessage } from '../../../../../Models/IStatusMessage';
import { IEventType } from '../../../../../Models/EventTypes/IEventType';
import { IEventTypeApi } from '../../../../../Services/API/EventType/IEventTypeApi';
import { EventTypePropertiesView } from './EventTypePropertiesView';
import { backendUrl } from '../../../../../Services/ConfigureService';
import { EventTypeEnum } from '../../../../../Models/Event/EventTypeEnum';

interface IEventTypePropertiesProps {
    item: IEventType;
    isOpen: boolean;
    close: () => void;
    refresh: (id: number) => void;
}

export const EventTypeProperties: React.FunctionComponent<IEventTypePropertiesProps> = (props) => {

    const [isLoading, setIsLoading] = useBoolean(false);
    const [editItem, setEditItem] = React.useState<IEventType>({ description: "", id: 0, name: "", longDescription: "", type: EventTypeEnum.Lessons, order: 0, showOnWeb: true });
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()
    const [isFormValid, setIsFormValid] = React.useState(false);

    const [iconUrl, setIconUrl] = React.useState<any>();
    const [iconFile, setIconFile] = React.useState<File>();

    const theme = useTheme();
    const iconClass = mergeStyles({
        fontSize: 50,
        height: 50,
        width: 50,
        margin: '0 25px',
        color: theme.palette.themePrimary
    });

    React.useEffect(() => {
        setEditItem(props.item);
        setIconUrl(backendUrl() + `api/EventType/GetImageByName/${props.item.id}?name=icon`);
        setIconFile(undefined);
    }, [props.item]);

    const propertyChanged = (key: string, value: any) => {
        setEditItem({ ...editItem, [key]: value });
    }

    const uploadImageIcon = async (eventTypeId: number, file: File) => {

        const ageGroupApi = Services.ServicesProvider.GetService<IEventTypeApi>(Services.EventTypeApi);
        const result = await ageGroupApi.eventTypeUploadImage(eventTypeId, "icon", file);
        if (result.isSuccess && result.data) {
            setIconUrl(backendUrl()+`api/EventType/GetImageByName/${eventTypeId}?name=icon`);
        }
        else {
            setStatusMessage({ message: result.message, type: MessageBarType.error });
        }
    }

    const updateAgeGroup = async (eventType: IEventType) => {

        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const ageGroupApi = Services.ServicesProvider.GetService<IEventTypeApi>(Services.EventTypeApi);
        const result = await ageGroupApi.updateEventType(eventType);

        if (result.isSuccess) {
            setStatusMessage({ message: result.message, type: MessageBarType.success });
            if (iconFile) {
                uploadImageIcon(props.item.id, iconFile)
            }
            await props.refresh(editItem.id);
            props.close();
        }
        else {
            setStatusMessage({ message: result.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    const createAgeGroup = async (eventType: IEventType) => {

        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const ageGroupApi = Services.ServicesProvider.GetService<IEventTypeApi>(Services.EventTypeApi);
        const result = await ageGroupApi.createEventType(eventType);

        if (result.isSuccess && result.data) {
            setStatusMessage({ message: result.message, type: MessageBarType.success });
            if (iconFile) {
                uploadImageIcon(props.item.id, iconFile)
            }
            await props.refresh(result.data);
            props.close();
        }
        else {
            setStatusMessage({ message: result.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }


    return (
        <>
            {props.isOpen ?
                <Panel
                    isOpen={props.isOpen}
                    onDismiss={props.close}
                    type={PanelType.medium}
                    closeButtonAriaLabel="Zavřít">
                    <Stack>
                        <Stack horizontal>
                            <Stack horizontalAlign='end' styles={{ root: { width: 80 } }}>
                                <FontIcon iconName="Event" className={iconClass} />
                            </Stack>

                            <Stack horizontal verticalAlign="center">
                                <Text styles={{ root: { fontWeight: 600 } }} variant="xLarge">                                    
                                    {props.item.id === 0 ? "Vytvoření nového typu události" : props.item.name}
                                </Text>
                            </Stack>
                        </Stack>
                        <EventTypePropertiesView setIcon={setIconFile} setIconUrl={setIconUrl} IconUrl={iconUrl} valid={setIsFormValid} item={editItem} propertyChanged={propertyChanged} isLoading={isLoading} />

                        <Stack styles={{ root: { height: 10 } }}>
                            {isLoading ? <ProgressIndicator /> : null}
                        </Stack>

                        <Stack horizontal tokens={{ padding: 20, childrenGap: 15 }} horizontalAlign="center">
                            <PrimaryButton disabled={!isFormValid} onClick={() => editItem.id > 0 ? updateAgeGroup(editItem) : createAgeGroup(editItem)}>Uložit</PrimaryButton>
                            <DefaultButton onClick={props.close}>Zavřít</DefaultButton>
                        </Stack>
                        {statusMessage && statusMessage.message ? <MessageBar messageBarType={statusMessage.type}>{statusMessage.message}</MessageBar> : null}
                    </Stack>
                </Panel> : null
            }
        </>)
}